import React, {useContext} from "react";
import PropTypes from "prop-types";
import {ATag} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import PivotMenu from "components/EntityList/Components/PivotMenu";
import {EntityListContext} from "contexts/EntityListContext";
import TooltipDelay from "../../TooltipDelay";
import css from "./EntityTitle.module.scss";

export const EntityTitle = ({
  title,
  tooltip,
  severity,
  showPivotMenu,
  pivotValues,
  minimal = false
}) => {
  const {withDrawer} = useContext(EntityListContext);

  const tooltipSubtitleFormatted =
    pivotValues?.type?.length > 0
      ? `${t(`observables.${pivotValues?.type}`)}: ${tooltip?.subtitle}`
      : tooltip?.subtitle;

  return (
    <div
      data-testid={"EntityListItem-Title"}
      className={classNames(css.title, "d-flex", {
        [css.titleMinimal]: minimal
      })}>
      {/* @todo Severity Tag color & linked to endpoint data */}
      {severity && <ATag className={"mr-1"}>{severity}</ATag>}
      <TooltipDelay
        title={tooltip?.title}
        subtitle={tooltipSubtitleFormatted}
        // Undefined so that the default TooltipDelay `position` will be used
        placement={withDrawer ? "left" : undefined}>
        <div className={css.titleText}>{title}</div>
      </TooltipDelay>
      {showPivotMenu && pivotValues && <PivotMenu pivotValues={pivotValues} />}
    </div>
  );
};

EntityTitle.propTypes = {
  /**
   * title string or element
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Object with `title` and `subtitle` keys to show as tooltip.
   */
  tooltip: PropTypes.object,
  /**
   * Content for severity/score chip
   */
  severity: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object
  ]),
  /**
   * Will render a pivot menu next to title if true
   * if `pivotValues` contains a valid type & value.
   */
  showPivotMenu: PropTypes.bool,
  /**
   * Values to pass to Pivot Menu component if showPivotMenu={true}
   */
  pivotValues: PropTypes.object,
  /**
   * Default Value: false - Render normal view (Cards, Drawers, etc.)
   * true - Renders a more compact view used by Tables. note that some sections
   * like 'subtitle' and 'rightSide' event counts are never show in this mode.
   */
  minimal: PropTypes.bool
};
